import dayjs, { Dayjs } from 'dayjs';

const endOf = (date: Dayjs) => {
  return date.set('hour', 23).set('minute', 59).set('second', 59);
};
const startOf = (date: Dayjs) => {
  return date.set('hour', 0).set('minute', 0).set('second', 0);
};

const formatter = (date?: any, format?: any, language?: string) => {
  if (date) {
    return dayjs(date)
      .locale(language === 'ar' ? 'ar-sa' : 'en')
      .format(format ?? 'YYYY-MM-DD');
  }
};

// Utility function to combine date and time strings into a Date object
const combineDateAndTime = (dateStr?: string, timeStr?: string): Date => {
  if (!dateStr) return new Date();
  
  if (!timeStr) {
    return new Date(dateStr);
  }
  
  // Convert 12-hour format to 24-hour format for proper Date parsing
  const [time, period] = timeStr.split(' ');
  const [hours, minutes] = time.split(':');
  let hour24 = parseInt(hours);
  
  if (period === 'PM' && hour24 !== 12) {
    hour24 += 12;
  } else if (period === 'AM' && hour24 === 12) {
    hour24 = 0;
  }
  
  const combinedDateTime = new Date(dateStr);
  combinedDateTime.setHours(hour24, parseInt(minutes), 0, 0);
  
  return combinedDateTime;
};

export { startOf, endOf, formatter, combineDateAndTime };
